const pillars = [
  {
    icon: '💬',
    title: 'A roster you navigate',
    description:
      'Every agent gets its own space and chat. Switch between your researcher, your engineer, and your chief of staff like switching between coworkers—no command line, no one giant assistant to wrangle.',
  },
  {
    icon: '🔐',
    title: 'Permissions at the agent level',
    description:
      'Each agent’s access is scoped to exactly what it should touch. A coworker can’t reach beyond its lane, so you always know what every agent is allowed to do.',
  },
  {
    icon: '🧩',
    title: 'Skills at the agent level',
    description:
      'Capabilities live on the agent that should have them. Behavior stays predictable and contained—no surprises, no rogue agents doing things you never asked for.',
  },
];

const Workspace = () => {
  return (
    <section className="workspace" id="workspace">
      <div className="section-container">
        <p className="overline overline--center">YOUR WORKSPACE</p>
        <h2 className="section-title">Agentic AI, finally approachable</h2>
        <p className="section-subtitle">
          Your Claude subscription, organized like a team you actually manage—not a sprawling CLI
          or one all-powerful assistant. Each coworker is easy to find, easy to direct, and safe to
          run.
        </p>

        <div className="workspace-grid">
          {pillars.map((p, i) => (
            <div key={i} className="workspace-card">
              <div className="feature-icon" aria-hidden="true">
                {p.icon}
              </div>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>

        <div className="workspace-note mono">
          You always know which coworker did what—and what each one is allowed to do.
        </div>
      </div>
    </section>
  );
};

export default Workspace;
